import React, { useState } from 'react';
import AAutoComplete from '../../../../../../views/pages/manage/common/form-fields-mui/AAutoComplete';
import ATextarea from '../../../../../../views/pages/manage/common/formFeilds/customInput/ATextarea';
import styles from "../../styles.module.scss";
import { OTHERS } from '../utils';
import UploadDocument from '../../../../../../views/pages/manage/edpOps/studentDetails/paymentSummary/studentBankDetails/UploadDocument';
import DocUploadModal from '../../../../../../views/pages/manage/unAssigned/studentCharges/studentChargesDetails/paymentMode/DocUploadModal';
import StudentDetailsCorrectionForm from './StudentDetailsCorrectionForm';
import { useWizard } from '../../../../../../components/wizard/WizardContext';

const labelStyle = { color: '#262626' };

const RefundDetails = ({
    paymentModesDropdown,
    refundDetailsForm,
    setRefundDetailsForm,
    paymodeChangeHandler,
    studentDetailsCorrectionForm,
    setStudentDetailsCorrectionForm,
    setLoading,
    showCorrectStudentDetailsForm,
    rectificationRefundReasons,
    setReceiptsData
}) => {

    const [addAttachmentDialogOpen, setAddAttachmentDialogOpen] = useState(false);

    const { setStepsConfig } = useWizard();

    const formHandler = (key, value) => {
        setRefundDetailsForm(prev => ({ ...prev, [key]: value }));
    }

    const updateStep = (stepIdx, updateValues) => {

        setStepsConfig(prev => {
            const steps = [...prev];
            const updatedStep = { ...steps[stepIdx], ...updateValues };
            steps[stepIdx] = updatedStep;
            return steps;
        });

    }

    const reasonChangeHandler = reason => {
        formHandler("rectificationReason", reason);
        formHandler("paymode", "");
        setReceiptsData([]);
        updateStep(2, { disabled: reason?.label === OTHERS });
    }

    return (
        <div className={`a-card m-0 mt-3 ${styles['refund-details-card']}`}>
            <h2>Refund Details</h2>


            <div className={styles['refund-reason-form']}>
                <AAutoComplete
                    label='Rectification Reason*'
                    items={rectificationRefundReasons}
                    isMulti={false}
                    handleChange={reasonChangeHandler}
                    currentValue={refundDetailsForm?.rectificationReason}
                    labelStyle={labelStyle}
                />

                <AAutoComplete
                    label='Paymode*'
                    items={paymentModesDropdown}
                    isMulti={false}
                    handleChange={paymodeChangeHandler}
                    currentValue={refundDetailsForm?.paymode}
                    labelStyle={labelStyle}
                    isDisabled={!refundDetailsForm?.rectificationReason}
                />


                <UploadDocument
                    setUploadDialogOpen={setAddAttachmentDialogOpen}
                    attachmentKey={refundDetailsForm?.attachmentKey}
                    formHandler={formHandler}
                    labelStyle={labelStyle}
                    label='Add Attachment*'
                />

                <div className={styles["rectification-reason"]}>
                    <ATextarea
                        label={"Remarks"}
                        onChange={remarks => formHandler("remarks", remarks)}
                        value={refundDetailsForm?.remarks}
                        labelStyle={labelStyle}
                        maxLength={300}
                    />
                </div>



            </div>

            {showCorrectStudentDetailsForm &&
                <StudentDetailsCorrectionForm
                    form={studentDetailsCorrectionForm}
                    setForm={setStudentDetailsCorrectionForm}
                    setLoading={setLoading}
                />
            }

            <DocUploadModal
                open={addAttachmentDialogOpen}
                setOpen={setAddAttachmentDialogOpen}
                acceptedFileTypes={[".jpg", ".jpeg", ".png", ".pdf"]}
                maxUploadFileSize={5}
                serviceName={'REFUND_SERVICE_ATTACHMENTS'}
                uniqueKeyParameter={"rectificationRefundAttachment"}
                uploadedFileS3Key={refundDetailsForm?.attachmentKey}
                uploadedFileName={"Account Details"}
                modalTitle={"Upload Attachment"}
                saveHandler={(s3Key) => {
                    setAddAttachmentDialogOpen(false);
                    formHandler("attachmentKey", s3Key)
                }}
                modalProps={{ zIndex: 1500 }}
                key={refundDetailsForm?.attachmentKey}
            />


        </div >
    );
}

export default RefundDetails;